import { IScheduleSectionFormValues } from '@src/features/shift-post-v2/steps/shift-details-step/components/schedule-section/schedule-section.types'
import {
  getFinalDay,
  updateSingleDayShift,
  updateSpecificDay,
} from 'ui/components/Admin/Shifts/ShiftEditDuplicate/utils'
import { TDay, TSingleDayShift } from 'ui/components/Admin/Shifts/ShiftEditDuplicate/utils/types'
import { MOMENT_FORMAT_STRING } from 'helpers/constants/constants'
import { SHIFT_TYPE } from 'models/Shift'
import { FormikProps } from 'formik'

export const handleHourChange = (
  value: string,
  formik: FormikProps<IScheduleSectionFormValues>,
  day: TSingleDayShift | TDay,
  isStartHour: boolean
) => {
  const {
    values: { days, single_day_shifts, type },
    setFieldValue,
  } = formik
  const { id } = day

  if (type === SHIFT_TYPE.SINGLEDAY) {
    setFieldValue(
      'single_day_shifts',
      updateSingleDayShift(single_day_shifts, String(id), {
        [isStartHour ? 'hour_start' : 'hour_end']: value,
      })
    )
  }

  if (type === SHIFT_TYPE.MULTIDAY && 'day_start' in day) {
    // Only update multiday days if this is a TDay (has day_start property)

    const dayEnd = getFinalDay(
      day.day_start,
      isStartHour ? value : day.hour_start,
      isStartHour ? day.hour_end : value
    )
    const updatedDays = updateSpecificDay(days, Number(id), {
      [isStartHour ? 'hour_start' : 'hour_end']: value,
      day_end: dayEnd,
      date_end: dayEnd.format(MOMENT_FORMAT_STRING.MM_DD_YYYY),
      is_dirty: true,
    })

    setFieldValue('days', updatedDays)
  }
}
